module.exports = __webpack_public_path__ + "static/media/umbrella-beach.eb41349f.svg";